import {
  ArrowRightLeft,
  ArrowRight,
  BriefcaseMedical,
  BrushCleaning,
  CalendarClock,
  Clock3,
  Check,
  CircleCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Droplets,
  FileText,
  Globe,
  Handshake,
  House,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  Package,
  PiggyBank,
  Phone,
  Plus,
  Recycle,
  Shield,
  Stamp,
  Star,
  TrendingUp,
  TriangleAlert,
  Truck,
  Users,
  Warehouse,
  Wrench,
  X,
  createIcons,
} from 'lucide';

const iconSet = {
  ArrowRightLeft,
  ArrowRight,
  BriefcaseMedical: FileText,
  BrushCleaning: Droplets,
  CalendarClock: Clock3,
  Clock3,
  Check,
  CircleCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Droplets,
  FileText,
  Globe,
  Handshake,
  House,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  Package,
  PiggyBank,
  Phone,
  Plus,
  Recycle,
  Shield,
  Stamp: FileText,
  Star,
  TrendingUp,
  TriangleAlert,
  Truck,
  Users,
  Warehouse: House,
  Wrench,
  X,
};

export default function initLucideIcons() {
  createIcons({ icons: iconSet });
}
